import { Tab } from '../../../../../../views/team/reports';

export default {
  tabs: {
    [Tab.General]: 'Yleiset',
    [Tab.SignedLive]: 'Allekirjoitettu / Käytössä',
    [Tab.MRR]: 'MRR',
    [Tab.CollectedCommission]: 'Provisio',
  },
};
